module.exports = __webpack_public_path__ + "static/367117_0_0-ce915ff8cd3533e4e1d3936d2e9bfdb7.woff2";